export default __webpack_public_path__ + "static/media/flying-tree.95b6040e.png";